<div class="container">
  <div class="form-signin">
    <h2 class="form-signin-heading">Sign In</h2>
    <div style="margin-bottom: 5px" class="form-text sub-title">Hello! Sign in with your username or email</div>

    <form (ngSubmit)="login()" #form="ngForm" autocomplete="nope">
      <div [hidden]="errors.length === 0">
        <p-messages [value]="errors" />
      </div>
      <div class="mb-3">
        <label for="input-email" class="sr-only">Email address</label>
        <input name="email" [(ngModel)]="model.username" id="input-email" pattern=".+@.+..+" class="form-control"
          placeholder="Email address" #email="ngModel" type="email" autofocus required />
        @if (email.invalid && email.touched && email.errors?.required) {
        <small class="form-text text-danger"> Email is required! </small>
        }
        @if (email.invalid && email.touched && email.errors?.pattern) {
        <small class="form-text text-danger"> Email should be the real one! </small>
        }
      </div>

      <div>
        <label for="input-password" class="sr-only">Password</label>
        <input name="password" [(ngModel)]="model.password" type="password" id="input-password" class="form-control"
          placeholder="Password" #password="ngModel" required />
        @if (password.invalid && password.touched && password.errors?.required) {
        <small class="form-text text-danger"> Password is required! </small>
        }
      </div>

      <div class="form-group accept-group col-sm-12">
        <a class="forgot-password" routerLink="../restore-password">Forgot Password?</a>
      </div>

      <button [disabled]="!form.valid" class="btn btn-lg btn-block btn-primary">Sign In</button>
    </form>

    <div class="alert alert-warning text-center" style="margin-top: 20px" role="alert">
      Microsoft's Internet Explorer is not supported by this application. Supported browsers are Apple Safari, Google
      Chrome, Microsoft Edge
      and Mozilla Firefox.
    </div>
  </div>
</div>